import { IEntitlement } from 'API/compassRights';
import {
  ICategoriesState,
  ICategory,
  IEntitlementsState,
} from 'Context/CompassRightsContext/EntitlementsProvider';

// Session Storage Keys
export const sessionTextSearch = 'COMPASS_RIGHTS_SEARCH_TEXT';
export const sessionCategoriesFilter = 'COMPASS_RIGHTS_CATEGORIES_FILTER';

export function EntitlementsReducer(state: IEntitlementsState, action: any) {
  switch (action.type) {
    case 'INITIALIZATION': {
      const textSearch = sessionStorage.getItem(sessionTextSearch);
      if (textSearch)
        return {
          allEntitlements: action.payload.value,
          filteredEntitlements: SearchEntitlement(
            textSearch,
            action.payload.value
          ),
        };
      const categoryFilter = sessionStorage.getItem(sessionCategoriesFilter);
      if (categoryFilter)
        return {
          allEntitlements: action.payload.value,
          filteredEntitlements: FilterEntitlementByCategory(
            JSON.parse(categoryFilter),
            action.payload.value
          ),
        };
      return {
        allEntitlements: action.payload.value,
        filteredEntitlements: action.payload.value,
      };
    }
    case 'SEARCH_ENTITLEMENT': {
      const filteredEntitlements = SearchEntitlement(
        action.payload.value,
        state.allEntitlements
      );
      sessionStorage.setItem(sessionTextSearch, action.payload.value);
      return { ...state, filteredEntitlements };
    }
    case 'FILTER_CATEGORIES': {
      const filteredEntitlements = FilterEntitlementByCategory(
        action.payload.value,
        state.allEntitlements
      );
      sessionStorage.setItem(
        sessionCategoriesFilter,
        JSON.stringify(action.payload.value)
      );
      return { ...state, filteredEntitlements };
    }
    case 'RESET': {
      const filteredEntitlements = state.allEntitlements;
      return { ...state, filteredEntitlements };
    }
  }

  return state;
}

/**
 * The algorithm uses 'INCLUDES' function for name and short explanation.
 * @param searchValue String search value.
 * @param filteredEntitlements Array of entitlements.
 * @returns Array of filtered entitlements.
 */
function SearchEntitlement(
  searchValue: string,
  filteredEntitlements: IEntitlement[]
) {
  return filteredEntitlements.filter((entitlement: IEntitlement) => {
    return (
      entitlement.name.includes(searchValue) ||
      entitlement.shortExplanation.includes(searchValue)
    );
  });
}

/**
 * Given a category list filters the entitlements list according to the checked fields.
 * @param categoryFilters Categories State object.
 * @param allEntitlements Entitlements Array.
 * @returns Array of filtered entitlements.
 */
function FilterEntitlementByCategory(
  categoryFilters: ICategoriesState[],
  allEntitlements: IEntitlement[]
) {
  if (
    categoryFilters
      .map((category: ICategoriesState) =>
        category.subCategories?.some(
          (subCategory: ICategory) => subCategory.checked
        )
      )
      .every((check: boolean) => !check)
  )
    return allEntitlements;

  // Creates an array of checked subCategory while saving the main category. Example: [ {mainCategory: 3 , subCategory: 1} ]
  const selectedMainSubCategoriesID = categoryFilters.flatMap(
    ({ id: mainCategoryID, subCategories }) =>
      subCategories
        .filter(({ checked }) => checked)
        .map(({ id: subCategoryID }) => ({ mainCategoryID, subCategoryID }))
  );

  // Finds entitlements where answer their mainCategory and subCategory exist in the array above.
  const filteredEntitlements = allEntitlements?.filter(
    ({ category, subCategory }: IEntitlement) =>
      selectedMainSubCategoriesID.some(
        ({ mainCategoryID, subCategoryID }) =>
          Number(category) === mainCategoryID &&
          Number(subCategory) === subCategoryID
      )
  );

  return filteredEntitlements;
}
